/**
 * @generated SignedSource<<ab44876d510d6521cd4472a6aeaf144b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GroupsFilterSelectedGroupsRefetchQuery$variables = {
  count?: number | null;
  cursor?: string | null;
  groupUuids?: ReadonlyArray<string | null> | null;
};
export type GroupsFilterSelectedGroupsRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"GroupsFilterSelectedGroups_query">;
};
export type GroupsFilterSelectedGroupsRefetchQuery = {
  response: GroupsFilterSelectedGroupsRefetchQuery$data;
  variables: GroupsFilterSelectedGroupsRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": 5,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "groupUuids"
  }
],
v1 = {
  "kind": "Variable",
  "name": "groupUuids",
  "variableName": "groupUuids"
},
v2 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v1/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GroupsFilterSelectedGroupsRefetchQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor"
          },
          (v1/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "GroupsFilterSelectedGroups_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GroupsFilterSelectedGroupsRefetchQuery",
    "selections": [
      {
        "alias": "selectedGroups",
        "args": (v2/*: any*/),
        "concreteType": "GroupConnection",
        "kind": "LinkedField",
        "name": "groups",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GroupEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Group",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "uuid",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "selectedGroups",
        "args": (v2/*: any*/),
        "filters": [
          "groupUuids"
        ],
        "handle": "connection",
        "key": "GroupsFilter_selectedGroups",
        "kind": "LinkedHandle",
        "name": "groups"
      }
    ]
  },
  "params": {
    "cacheID": "bf18e7c2ef1ac07cbd75d5c53f67f10f",
    "id": null,
    "metadata": {},
    "name": "GroupsFilterSelectedGroupsRefetchQuery",
    "operationKind": "query",
    "text": "query GroupsFilterSelectedGroupsRefetchQuery(\n  $count: Int = 5\n  $cursor: String\n  $groupUuids: [String]\n) {\n  ...GroupsFilterSelectedGroups_query_1Kgcwl\n}\n\nfragment GroupsFilterSelectedGroups_query_1Kgcwl on Query {\n  selectedGroups: groups(after: $cursor, first: $count, groupUuids: $groupUuids) {\n    edges {\n      node {\n        id\n        uuid\n        name\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "59625217743f1535040a752a2ba74afc";

export default node;
